import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=608cb72d&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "../assets/css/list.scss?vue&type=style&index=0&id=608cb72d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608cb72d",
  null
  
)

export default component.exports